import { useCallback } from "react";

export interface ISaveFile {
    name: string;
    url: string;
}

export const useSaveFile = () => {
    const saveFileId = "saveFile";

    const getSaveFiles = useCallback(() => {
        const saveFiles = localStorage.getItem(saveFileId);

        if (saveFiles) {
            return JSON.parse(saveFiles) as Array<ISaveFile>;
        }

        return [];
    }, []);

    const saveFile = (name: string, url: string) => {
        const saveFiles = getSaveFiles();

        // remove existing save file with the same name
        if (saveFiles.some(x => x.name === name)) {
            const duplicateFileIndex = saveFiles.findIndex(x => x.name === name);
            saveFiles.splice(duplicateFileIndex, 1);
        }

        saveFiles.push({ name, url });
        localStorage.setItem(saveFileId, JSON.stringify(saveFiles));
    };

    const removeSaveFile = useCallback(
        (name: string) => {
            const saveFiles = getSaveFiles();
            const newSaveFiles = saveFiles.filter(x => x.name !== name);
            localStorage.setItem(saveFileId, JSON.stringify(newSaveFiles));
        },
        [getSaveFiles],
    );

    return { getSaveFiles, saveFile, removeSaveFile };
};
